<template>
  <el-form ref="form" :model="curInput.form" :rules="rules" label-width="100px">
    <el-form-item label="数据限制" prop="write_num">
      <el-input type="number" v-model.number="curInput.form.write_num" class="h-40 w-200"></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    props: ['curInput'],
    data() {
      return {
        rules: {
          write_num: [
            { required: true, message: '请填写数据限制' }
          ]
        }
      }
    },
    methods: {
    }
  }
</script>


// WEBPACK FOOTER //
// subformConfig.vue?075c3c86